import { values, groupBy, orderBy } from 'lodash';

export function series(state) {
  return state.series;
}

export function seriesList(state) {
  return orderBy(values(state.series), ['created_at'], ['desc']);
}

export function nonSeriesCards(state) {
  return state.nonSeriesCards;
}

export function nonSeriesCardList(state) {
  return orderBy(values(state.nonSeriesCards), ['created_at'], ['desc']);
}

export function chapters(state) {
  return state.chapters;
}

export function chapterList(state) {
  return orderBy(values(state.chapters), ['series_id', 'position'], ['asc']);
}

export function chaptersBySeriesId(state, getters) {
  return groupBy(getters.chapterList, 'series_id');
}

export function chapterCards(state) {
  return state.chapterCards;
}

export function chapterCardList(state) {
  return orderBy(values(state.chapterCards), ['chapter_id', 'position'], ['asc']);
}

export function cardsByChapterId(state, getters) {
  return groupBy(getters.chapterCardList, 'chapter_id');
}

export function videoCourseCard(state) {
  return state.videoCourseCard || {};
}

export function isLoadingVideoCourseCard(state) {
  return state.isLoadingVideoCourseCard;
}



// WEBPACK FOOTER //
// ./src/app/publishers/store/getters.js